/** HR departments */
export const HR_DEPARTMENTS = ['HR', 'HR-HEAD'];

/** IT Admin departments */
export const IT_ADMIN_DEPARTMENTS = ['IT-ADMIN'];

/**
 * Departments with management rights in inventory and workstation modules.
 * HR, HR-HEAD, and IT-ADMIN hold equivalent permissions (View All Requests, Approve, Reject, Assign, Create, Update).
 */
export const INVENTORY_MANAGER_DEPARTMENTS = ['HR', 'HR-HEAD', 'IT-ADMIN'];

/**
 * Departments allowed as approvers in inventory and service request forms.
 * Only users belonging to these departments can be selected as approvers.
 */
export const INVENTORY_APPROVER_DEPARTMENTS = ['ADMIN', 'IT-ADMIN', 'HR-HEAD', 'HR'];

export const isHrDept = (department: string | null | undefined): boolean =>
  HR_DEPARTMENTS.includes(String(department || '').trim().toUpperCase());

export const isItAdminDept = (department: string | null | undefined): boolean =>
  IT_ADMIN_DEPARTMENTS.includes(String(department || '').trim().toUpperCase());

export const isHrOrItAdminDept = (department: string | null | undefined): boolean =>
  INVENTORY_MANAGER_DEPARTMENTS.includes(String(department || '').trim().toUpperCase());

export const isInventoryApproverDept = (department: string | null | undefined): boolean =>
  INVENTORY_APPROVER_DEPARTMENTS.includes(String(department || '').trim().toUpperCase());

/** Alias for isHrOrItAdminDept */
export const isInventoryAdminDept = isHrOrItAdminDept;
